







"use strict";

const Localizer = require("./localize");
const {defaultReadyHandler: readyHandler} = require("./ready-handler");
const {AuthHandler} = require("./auth-util");
const {ajax} = require("./ajax-util");








class AppPage {
    

























    constructor(params) {
        this.authHandler = new AuthHandler();
        this.loginCallback = params.loginCallback ? params.loginCallback.bind(this.authHandler)
            : this.authHandler.defaultLoginCallback.bind(this.authHandler);
        this.onLoginError = params.onLoginError ? params.onLoginError.bind(this)
            : params.onAjaxAuthError || (errorDetail => {
                let errorStr = JSON.stringify(errorDetail, null, 2);
                alert(`TODO authentication error:\n ${errorStr}`);
                this.logout(errorDetail);
            });
        this._onAjaxAuthError = params.onAjaxAuthError || params.onLoginError || (err => {
            if (err.status === 401 || err.status === 403) {
                let errorStr = JSON.stringify(err, null, 2);
                alert(`TODO authentication error:\n ${errorStr}\n Press [OK] to go to Login Page.`);
                this.logout(err);
            } else {
                $.xux.showAjaxErrorModalWindow();
            }
        });
        this._supportedLang = params.supportedLang;
        this.logoutUrl = params.logoutUrl;
        this.sessionTimeout = params.sessionTimeout;
        this.l10n = null;
    }

    




    init(needAuth) {
        if (this._supportedLang) {
            this.l10n = new Localizer({
                readyHandler,
                supportedLang: this._supportedLang
            });
        }
        if (needAuth) {
            try {
                this.authHandler.checkLogined(() => this.loginCallback());
                readyHandler.addAfterVisibleCallback(this._initSessionRefreshManager.bind(this));
            } catch (err) {
                readyHandler.addAfterVisibleCallback(() => this.onLoginError(err));
            }
        }
    }

    




    get session() {
        return this.authHandler.getSession();
    }

    






    ajaxAuth(ajaxOption) {
        if (ajaxOption.asynAjax) {
            return this.authHandler.ajaxAuth(ajaxOption)
                .then(data => {
                    this._startAutoRefreshTimer();
                    this._startAutoLogoutTimer();
                    return data;
                });
        }
        return this.authHandler.ajaxAuth(ajaxOption)
            .then(data => {
                this._startAutoRefreshTimer();
                this._startAutoLogoutTimer();
                return data;
            })
            .fail(err => {
                this._onAjaxAuthError(err, this.loginCallback);
            });
    }

    






    ready(callback) {
        readyHandler.addBeforeVisibleCallback(callback);
    }

    









    logout(err, goto) {
        let self = this;

        function doLogout() {
            let url = self.logoutUrl;

            ajax({url}).then((data, status, xhr) => {
                self.authHandler.clear();
                let location = xhr.getResponseHeader("Location");
                
                

                window.location = goto || location;
            }).catch(() => {
                $.xux.showAjaxErrorModalWindow();
            });
        }

        
        
        if (err) {
            err.needReLogin ? self.loginCallback() : doLogout();
            return;
        }

        let session = self.session;

        if (!session 
            || (session.exp && session.exp * 1000 <= Date.now())) { 
            self.loginCallback();
        } else {
            
            doLogout();
        }
    }

    _createSessionRefreshManagerFrame() {
        let frame = document.getElementById("session-manager-frame");
        if (!frame) {
            let ifr = document.createElement("iframe");
            ifr.id = "session-manager-frame";
            ifr.style.display = "none";
            ifr.style.position = "absolute";
            ifr.style.width = ifr.style.height = ifr.style.borderWidth = "0px";
            let body = document.querySelector("body");
            if (body) {
                frame = body.appendChild(ifr);
            }
        }
    }

    _doAutoRefresh() {
        this.authHandler.defaultLoginCallback(data => {
            document.getElementById("session-manager-frame").src
                = this.authHandler.saveloginData(data);
            autoRefreshTimer = null;
        });
        
    }

    _getAutoRefreshDelay() {
        if (!this.session) {
            return undefined;
        }

        let exp = this.session.exp;
        let iat = this.session.iat;
        let now = Date.now();

        
        
        if (now - (iat * 1000) < 10 * 1000) {
            return undefined;
        }

        
        let autoRefreshTime = (exp - 60) * 1000;
        if (autoRefreshTime > now) {
            return autoRefreshTime - now;
        } else if (autoRefreshTime <= now && now < exp * 1000) {
            
            return 0;
        } else {
            
            return undefined;
        }
    }

    _startAutoRefreshTimer() {
        
        if (autoRefreshTimer) {
            return;
        }

        let autoRefreshDelay = this._getAutoRefreshDelay();
        if (autoRefreshDelay !== undefined) {
            autoRefreshTimer = setTimeout(this._doAutoRefresh.bind(this), autoRefreshDelay);
        }
    }

    _doAutoLogout() {
        let url = this.logoutUrl;
        ajax({url}).then((data, status, xhr) => {
            this.authHandler.clear();
            
            document.getElementById("session-manager-frame").src = xhr.getResponseHeader("Location");
            autoLogoutTimer = null;
        });
        
    }

    _startAutoLogoutTimer() {
        if (autoLogoutTimer) {
            clearTimeout(autoLogoutTimer);
        }
        if (!this.sessionTimeout) {
            let session = this.session;
            this.sessionTimeout = session.exp - session.iat;
        }
        autoLogoutTimer = setTimeout(this._doAutoLogout.bind(this), this.sessionTimeout * 1000);
    }

    











    _initSessionRefreshManager() {
        if (this.session) {
            this._createSessionRefreshManagerFrame();
            this._startAutoRefreshTimer();
            this._startAutoLogoutTimer();
        }
    }
}

let autoLogoutTimer = null;
let autoRefreshTimer = null;

module.exports = AppPage;
